import { createApp } from 'vue';
import MapApp from '../components/MapApp.vue';

export default class Map {
	constructor() {
		document.addEventListener('bless', (e) => {
			const container = e.target;
			const elms = container.querySelectorAll('[data-map]');

			elms.forEach((elm) => {
				this.init(elm);
			});
		});
	}

	init(elm) {
		const data = JSON.parse(elm.querySelector('script').textContent);
		createApp(MapApp, data).mount(elm);
	}
}
